var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"episodes-filter"},[_c('filter-form',_vm._b({},'filter-form',_vm.schema,false))],1)}
var staticRenderFns = []

export { render, staticRenderFns }